<div class="main-content pt-4">
  <div class="container-fluid">
    <!-- Loading -->
    <div *ngIf="loading" class="text-center py-5">
      <div class="spinner-border text-primary" role="status"></div>
      <p class="mt-2 text-muted">Loading campaign data...</p>
    </div>

    <div class="reviews-container p-4" *ngIf="!loading">

    <div *ngIf="!loading && campaign">
      <!-- ===== HEADER ROW: Title (left) + Discovery Context (right) ===== -->
      <div class="row align-items-center mb-4">
        <!-- LEFT: Title block -->
        <div class="col-md-8">
          <div class="d-flex align-items-center">
            <div class="title-icon-box mr-3">
              <i class="material-icons">travel_explore</i>
            </div>
            <div>
              <h1 class="review-main-title mb-0">Keyword Results Review</h1>
              <p class="review-subtitle mb-0">
                Top {{ totalSuggested }} qualified keyword opportunities for
                your review. AI may recommend up to ~8 for Active Priority.
              </p>
            </div>
          </div>
        </div>

        <!-- RIGHT: Discovery Context Card -->
        <div class="col-md-4">
          <div class="discovery-context-card">
            <div class="discovery-context-label">Discovery Context</div>
            <div class="discovery-context-meta">
              <span class="dc-location">{{
                getLocationLabel(campaign?.location)
              }}</span>
              <span class="dc-dot">•</span>
              <span>{{ getUniverseLabel(campaign?.universe) }}</span>
              <span class="dc-dot">•</span>
              <span>{{ getCategoryLabel(campaign?.category) }}</span>
            </div>
            <div class="dc-goal">
              <strong>Goal:</strong>
              <strong>{{ getConversionGoalLabel(campaign?.conversionGoal) }}</strong>
            </div>
            <div class="dc-actions-row mt-2">
              <a href="javascript:void(0)" class="dc-link">View Details</a>
            </div>
          </div>
        </div>
      </div>

      <!-- ===== STATS ROW ===== -->
      <div class="row mb-4">
        <div class="col-12">
          <div class="card m-0 w-100 stats-card">
            <div class="card-body p-0">
              <div class="row m-0 align-items-center">
                <!-- Stat 1 -->
                <div class="col-md-3 stats-item-container">
                  <div class="stats-item">
                    <div class="stats-icon-wrap stats-icon-blue">
                      <i class="material-icons">bar_chart</i>
                    </div>
                    <div>
                      <div class="stats-value">{{ totalSuggested }}</div>
                      <div class="stats-label">Qualified Opportunities</div>
                      <div class="stats-sub">
                        Top {{ totalSuggested }} for review
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Stat 2 -->
                <div class="col-md-3 stats-item-container">
                  <div class="stats-item">
                    <div class="stats-icon-wrap stats-icon-green">
                      <i class="material-icons">person_add</i>
                    </div>
                    <div>
                      <div class="stats-value">{{ aiActiveCount }}</div>
                      <div class="stats-label">AI Active Recommendations</div>
                      <div class="stats-sub">Up to ~8 suggested</div>
                    </div>
                  </div>
                </div>

                <!-- Stat 3 -->
                <div class="col-md-3 stats-item-container">
                  <div class="stats-item">
                    <div class="stats-icon-wrap stats-icon-teal">
                      <i class="material-icons">settings</i>
                    </div>
                    <div>
                      <div class="stats-value">{{ totalEstVolume }}</div>
                      <div class="stats-label">Total Est. Volume</div>
                      <div class="stats-sub">
                        Across all {{ totalSuggested }}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Stat 4 -->
                <div class="col-md-3 stats-item-container">
                  <div class="stats-item stats-item-score">
                    <div class="opp-score-ring">
                      <svg viewBox="0 0 36 36" class="opp-ring-svg">
                        <path
                          class="ring-bg"
                          d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                        />
                        <path
                          class="ring-fill"
                          stroke-dasharray="72, 100"
                          d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                        />
                      </svg>
                      <div class="opp-ring-number">
                        {{ avgOpportunityScore }}
                      </div>
                    </div>
                    <div>
                      <div class="stats-label">Opportunity Score Avg.</div>
                      <div class="stats-sub">
                        Average across {{ totalSuggested }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <!-- ===== KEYWORDS TABLE ===== -->
          <div
            class="card mb-0"
            style="
              border-bottom-left-radius: 0;
              border-bottom-right-radius: 0;
              border-bottom: none;
            "
          >
            <div class="card-body p-0">
              <div class="table-responsive">
                <table class="table table-hover kw-table mb-0">
                  <thead class="kw-thead">
                    <tr>
                      <th class="kw-th-check">
                        <div class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            id="checkAll"
                            [checked]="allSelected"
                            (change)="toggleSelectAll($event)"
                          />
                          <label
                            class="custom-control-label"
                            for="checkAll"
                          ></label>
                        </div>
                      </th>
                      <th class="kw-th">
                        <strong>Keyword</strong>
                        <i class="material-icons sort-icon">unfold_more</i>
                      </th>
                      <th class="kw-th"><strong>Observed Intent</strong></th>
                      <th class="kw-th"><strong>Competition</strong></th>
                      <th class="kw-th">
                        <strong>Est. Volume</strong>
                        <i
                          class="material-icons info-icon"
                          title="Estimated monthly search volume"
                          >info</i
                        >
                      </th>
                      <th class="kw-th">
                        <strong>Commercial Value</strong>
                        <i class="material-icons info-icon">info</i>
                      </th>
                      <th class="kw-th">
                        <strong>Conv. Align.</strong>
                        <i class="material-icons info-icon">info</i>
                      </th>
                      <th class="kw-th">
                        <strong>Opp. Score</strong>
                        <i class="material-icons info-icon">info</i>
                      </th>
                      <th class="kw-th">
                        <strong>Opp. Rank</strong>
                        <i class="material-icons info-icon">info</i>
                      </th>
                      <th class="kw-th">
                        <strong>Registry Match</strong>
                        <i class="material-icons info-icon">info</i>
                      </th>
                      <th class="kw-th"><strong>AI Recommendation</strong></th>
                      <th class="kw-th">
                        <strong>AI Confidence</strong>
                        <i class="material-icons info-icon">info</i>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="let kw of campaign?.keywords; let i = index"
                      class="kw-row"
                      [class.kw-row-selected]="isKeywordSelected(kw.status)"
                      (click)="selectKeyword(i)"
                    >
                      <td
                        class="kw-td-check"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            [id]="'kwcheck' + i"
                            [checked]="isKeywordSelected(kw.status)"
                            (change)="toggleKeywordStatus(i, $event)"
                          />
                          <label
                            class="custom-control-label"
                            [for]="'kwcheck' + i"
                          ></label>
                        </div>
                      </td>
                      <td class="kw-name-cell">
                        <a href="javascript:void(0)" class="kw-name-link">{{
                          kw.value
                        }}</a>
                      </td>
                      <td class="kw-td text-muted small">
                        {{ getKeywordIntentLabel(campaign?.keywordIntent) }}
                      </td>
                      <td class="kw-td text-muted small">
                        {{
                          kw.competition ||
                            getCompetitionTargetLabel(
                              campaign?.competitionTarget
                            )
                        }}
                      </td>
                      <td class="kw-td text-muted small">
                        {{ kw.estVolume || "—" }}
                      </td>
                      <td class="kw-td">
                        <span class="badge-pill-value badge-high">{{
                          kw.commercialValue || "High"
                        }}</span>
                      </td>
                      <td class="kw-td text-muted small">
                        {{ kw.convAlign || "Very High" }}
                      </td>
                      <td class="kw-td font-weight-bold small">
                        {{ kw.oppScore || "—" }}
                      </td>
                      <td class="kw-td text-muted small">#{{ i + 1 }}</td>
                      <td class="kw-td">
                        <span
                          class="badge registry-badge"
                          [ngClass]="getRegistryBadgeClass(kw.registryMatch)"
                        >
                          {{ kw.registryMatch || "Net-New" }}
                        </span>
                      </td>
                      <td class="kw-td">
                        <span
                          class="ai-rec-badge"
                          [ngClass]="
                            getAiRecBadgeClass(kw.aiRecommendation || kw.status)
                          "
                        >
                          {{ getAiRecLabel(kw.aiRecommendation || kw.status) }}
                        </span>
                      </td>
                      <td class="kw-td font-weight-bold small">
                        {{ kw.aiConfidence ? kw.aiConfidence + "%" : "—" }}
                      </td>
                    </tr>

                    <tr
                      *ngIf="
                        !campaign?.keywords || campaign.keywords.length === 0
                      "
                    >
                      <td colspan="12" class="text-center py-5 text-muted">
                        No suggested keywords found in this campaign.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- ===== TABLE FOOTER BAR ===== -->
          <div class="table-footer-bar mb-4 w-100">
            <div class="tfb-left">
              <span class="tfb-count"
                >{{ totalSelected }} of {{ totalSuggested }} selected</span
              >
              <span class="tfb-legend">
                <span class="legend-dot legend-active"></span> Active
                Recommendation
              </span>
              <span class="tfb-legend">
                <span class="legend-dot legend-consider"></span> Consider
              </span>
              <span class="tfb-legend">
                <span class="legend-dot legend-bank"></span> Bank
              </span>
            </div>
            <div class="tfb-right">
              <button
                class="btn btn-ai-reconsider mr-2"
                (click)="askAiReconsider()"
              >
                <i class="material-icons btn-icon">auto_awesome</i>
                Ask AI to Reconsider Selection
              </button>
              <button
                class="btn btn-outline-secondary btn-sm"
                (click)="selectAll(false)"
              >
                Clear All
              </button>
            </div>
          </div>

          <!-- ===== SELECTED KEYWORD DETAIL PANEL ===== -->
          <div
            class="card mb-4 selected-kw-panel"
            *ngIf="selectedKeyword !== null"
          >
            <div class="card-body">
              <div class="skw-header">
                <div class="skw-title-block">
                  <div class="skw-label"><strong>Selected Opportunity Review</strong></div>
                  <div class="skw-name-row">
                    <span class="skw-kw-name">{{
                      campaign?.keywords[selectedKeyword]?.value
                    }}</span>
                    <span class="badge-intent-tag ml-2">{{
                      getKeywordIntentLabel(campaign?.keywordIntent)
                    }}</span>
                  </div>
                  <div class="skw-metrics-row mt-3">
                    <div class="skw-metric">
                      <div class="skw-metric-label"><strong>Est. Volume</strong></div>
                      <div class="skw-metric-value">
                        {{
                          campaign?.keywords[selectedKeyword]?.estVolume || "—"
                        }}
                      </div>
                    </div>
                    <div class="skw-metric">
                      <div class="skw-metric-label"><strong>Competition</strong></div>
                      <div class="skw-metric-value">
                        {{
                          campaign?.keywords[selectedKeyword]?.competition ||
                            getCompetitionTargetLabel(
                              campaign?.competitionTarget
                            )
                        }}
                      </div>
                    </div>
                    <div class="skw-metric">
                      <div class="skw-metric-label"><strong>Commercial Value</strong></div>
                      <div class="skw-metric-value">
                        {{
                          campaign?.keywords[selectedKeyword]
                            ?.commercialValue || "High"
                        }}
                      </div>
                    </div>
                    <div class="skw-metric">
                      <div class="skw-metric-label"><strong>Conversion Alignment</strong></div>
                      <div class="skw-metric-value">
                        {{
                          campaign?.keywords[selectedKeyword]?.convAlign ||
                            "Very High"
                        }}
                      </div>
                    </div>
                  </div>
                  <div class="skw-metrics-row mt-2">
                    <div class="skw-metric">
                      <div class="skw-metric-label"><strong>Opportunity Score</strong></div>
                      <div class="skw-metric-value font-weight-bold">
                        {{
                          campaign?.keywords[selectedKeyword]?.oppScore || "—"
                        }}
                        / 100
                      </div>
                    </div>
                    <div class="skw-metric">
                      <div class="skw-metric-label"><strong>Opportunity Rank</strong></div>
                      <div class="skw-metric-value font-weight-bold">
                        #{{ selectedKeyword + 1 }} of {{ totalSuggested }}
                      </div>
                    </div>
                    <div class="skw-metric">
                      <div class="skw-metric-label"><strong>Registry Match</strong></div>
                      <div class="skw-metric-value">
                        {{
                          campaign?.keywords[selectedKeyword]?.registryMatch ||
                            "Net-New"
                        }}
                        <i
                          class="material-icons"
                          style="
                            font-size: 14px;
                            vertical-align: middle;
                            color: #888;
                          "
                          >link</i
                        >
                      </div>
                    </div>
                  </div>
                </div>

                <!-- AI Recommendation + AI Confidence + AI Rationale column -->
                <div class="skw-ai-col">
                  <!-- AI Recommendation -->
                  <div class="skw-ai-rec-block">
                    <div class="skw-ai-rec-label"><strong>AI Recommendation</strong></div>
                    <div class="skw-ai-rec-value">
                      <span class="ai-rec-badge ai-rec-active">
                        <i
                          class="material-icons"
                          style="font-size: 14px; vertical-align: middle"
                          >check_circle</i
                        >
                        {{
                          getAiRecLabel(
                            campaign?.keywords[selectedKeyword]
                              ?.aiRecommendation ||
                              campaign?.keywords[selectedKeyword]?.status
                          )
                        }}
                      </span>
                    </div>
                    <div class="skw-ai-sub mt-1">
                      Top AI recommended keyword
                    </div>
                  </div>

                  <!-- AI Confidence -->
                  <div class="skw-ai-conf-block">
                    <div class="skw-ai-rec-label"><strong>AI Confidence</strong></div>
                    <div class="skw-conf-pct">
                      {{
                        campaign?.keywords[selectedKeyword]?.aiConfidence
                          ? campaign?.keywords[selectedKeyword]?.aiConfidence +
                            "%"
                          : "—"
                      }}
                    </div>
                    <div class="skw-conf-level">
                      <a href="javascript:void(0)" class="dc-link text-success"
                        >Very High</a
                      >
                    </div>
                  </div>

                  <!-- AI Rationale (below, same column) -->
                  <div class="skw-rationale mt-3">
                    <div class="skw-rationale-label"><strong>AI Rationale</strong></div>
                    <div class="skw-rationale-text">
                      {{
                        campaign?.keywords[selectedKeyword]?.aiRationale ||
                          "Very strong commercial intent with high conversion alignment. Significant local demand. Competitive but attainable. Direct alignment with conversion goal: " +
                            getConversionGoalLabel(campaign?.conversionGoal) +
                            "."
                      }}
                    </div>
                  </div>
                </div>

                <!-- Actions column -->
                <div class="skw-actions-block">
                  <div class="skw-ai-rec-label"><strong>Actions</strong></div>
                  <button
                    class="btn btn-action-deselect mb-2"
                    (click)="toggleKeywordStatusByIndex(selectedKeyword)"
                  >
                    <i class="material-icons btn-icon text-danger"
                      >delete_outline</i
                    >
                    {{
                      isKeywordSelected(
                        campaign?.keywords[selectedKeyword]?.status
                      )
                        ? "Deselect"
                        : "Select"
                    }}
                  </button>
                  <button
                    class="btn btn-action-secondary mb-2"
                    (click)="askAiReconsider()"
                  >
                    <i class="material-icons btn-icon">auto_awesome</i>
                    Ask AI to Reconsider
                  </button>
                  <button
                    class="btn btn-action-secondary"
                    (click)="addReviewNote()"
                  >
                    <i class="material-icons btn-icon">note_add</i>
                    Add Review Notes
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- ===== BOTTOM SECTION: Notes + After Save + Save Button ===== -->
          <div class="bottom-section-row mb-5">
            <!-- Review Notes -->
            <div class="bottom-notes-block card">
              <div class="card-body">
                <div class="d-flex align-items-center mb-2">
                  <strong class="mr-2">Review Notes</strong>
                  <i
                    class="material-icons"
                    style="font-size: 16px; color: #888; cursor: pointer"
                    >edit</i
                  >
                </div>
                <p class="text-muted small mb-2">
                  Optional notes about this selection set
                </p>
                <textarea
                  class="form-control review-notes-area"
                  rows="3"
                  [(ngModel)]="reviewNotes"
                  placeholder="Add your review notes here..."
                ></textarea>
              </div>
            </div>

            <!-- After Save Info -->
            <div class="bottom-aftersave-block card">
              <div class="card-body">
                <div class="aftersave-title">After SAVE</div>
                <ul class="aftersave-list">
                  <li><strong>Selected</strong> = Active Priority</li>
                  <li><strong>Valid non-selected</strong> = Banked</li>
                </ul>
                <p class="text-muted small mb-0">
                  Results will reconcile with existing keyword intelligence.
                </p>
              </div>
            </div>

            <!-- Save Button -->
            <div class="bottom-aftersave-block card">
              <div class="card-body">
                <div class="bottom-save-block">
                  <button
                    class="btn btn-save-main"
                    (click)="save()"
                    [disabled]="saving"
                  >
                    {{ saving ? "Saving..." : "SAVE" }}
                    <span class="save-sub">Commit reviewed opportunities</span>
                    <i class="material-icons btn-icon">lock_open</i>
                  </button>
                </div>
              </div>
            </div>

            <!-- Post-save Note -->
            <div class="bottom-aftersave-block card">
              <div class="card-body">
                <div class="bottom-postsave-note">
                  <i class="material-icons" style="font-size: 18px; color: #888"
                    >lock</i
                  >
                  <span class="small text-muted ml-1"
                    >This is the institutional commit. Results will be
                    reconciled before registration.</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /ngIf campaign -->
      </div>
    </div>
    </div>
  </div>
</div>
